export default {"src":"/_next/static/media/growth.19187f2f.svg","height":63,"width":103,"blurWidth":0,"blurHeight":0};